// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.magicform-chat-history {
  /* border: 1px solid floralwhite !important; */
  display: flex !important;
  flex-direction: column-reverse !important;
  padding: 1rem 1rem !important;
  overflow-y: scroll !important;
  flex-grow: 1 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  background-color: white !important;
}

.magicform-chat-history-minimal {
  /* border: 1px solid floralwhite !important; */
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  padding: 1rem 1rem !important;
  flex-grow: 1 !important;
  box-sizing: border-box !important;
  width: 100% !important;
  /* background-color: blue!important; */
}

.magicform-chat-history-show-scrollbar {
  overflow-y: scroll !important;
}

.magicform-chat-history-hide-scrollbar {
  overflow-y: hidden !important;
}

.magicform-chat-history-empty {
  visibility: hidden !important;
}
.magicform-delete-button {
  margin: 0 4px !important;
  padding: 0 4px !important;
  border-radius: 50% !important;
  /*border: 1px solid black !important;*/
  color: black !important;
  font-weight: 800 !important;
  font-size: 1rem !important;
  cursor: pointer !important;
  /* background-color: rgb(248, 248, 248, 0.5) !important; */
}

.magicform-scroll-anchor {
  /*
    This plus scroll-anchor used to pin chat conversation to the latest messages
    refer to: https://css-tricks.com/books/greatest-css-tricks/pin-scrolling-to-bottom/
    */
  overflow-anchor: none !important;
  height: 1px !important;
}

.check-fade-in {
  opacity: 0;
  scale: 0;
  animation: fadeIn 0.3s linear forwards, grow 0.2s linear forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes grow {
  to {
    scale: 1;
  }
}

.magicform-speaker-button {
  transition: background-color .1s ease-in-out;
  background-color: transparent;
}

.magicform-speaker-button:hover {
  transition: background-color .1s ease-in-out;
  background-color: lightgrey;
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatHistory/ChatHistory.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,wBAAwB;EACxB,yCAAyC;EACzC,6BAA6B;EAC7B,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,8CAA8C;EAC9C,wBAAwB;EACxB,iCAAiC;EACjC,gCAAgC;EAChC,6BAA6B;EAC7B,uBAAuB;EACvB,iCAAiC;EACjC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,6BAA6B;EAC7B,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE;;;KAGG;EACH,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iEAAiE;AACnE;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,4CAA4C;EAC5C,6BAA6B;AAC/B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B","sourcesContent":[".magicform-chat-history {\n  /* border: 1px solid floralwhite !important; */\n  display: flex !important;\n  flex-direction: column-reverse !important;\n  padding: 1rem 1rem !important;\n  overflow-y: scroll !important;\n  flex-grow: 1 !important;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  background-color: white !important;\n}\n\n.magicform-chat-history-minimal {\n  /* border: 1px solid floralwhite !important; */\n  display: flex !important;\n  flex-direction: column !important;\n  align-items: flex-end !important;\n  padding: 1rem 1rem !important;\n  flex-grow: 1 !important;\n  box-sizing: border-box !important;\n  width: 100% !important;\n  /* background-color: blue!important; */\n}\n\n.magicform-chat-history-show-scrollbar {\n  overflow-y: scroll !important;\n}\n\n.magicform-chat-history-hide-scrollbar {\n  overflow-y: hidden !important;\n}\n\n.magicform-chat-history-empty {\n  visibility: hidden !important;\n}\n.magicform-delete-button {\n  margin: 0 4px !important;\n  padding: 0 4px !important;\n  border-radius: 50% !important;\n  /*border: 1px solid black !important;*/\n  color: black !important;\n  font-weight: 800 !important;\n  font-size: 1rem !important;\n  cursor: pointer !important;\n  /* background-color: rgb(248, 248, 248, 0.5) !important; */\n}\n\n.magicform-scroll-anchor {\n  /*\n    This plus scroll-anchor used to pin chat conversation to the latest messages\n    refer to: https://css-tricks.com/books/greatest-css-tricks/pin-scrolling-to-bottom/\n    */\n  overflow-anchor: none !important;\n  height: 1px !important;\n}\n\n.check-fade-in {\n  opacity: 0;\n  scale: 0;\n  animation: fadeIn 0.3s linear forwards, grow 0.2s linear forwards;\n}\n\n@keyframes fadeIn {\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes grow {\n  to {\n    scale: 1;\n  }\n}\n\n.magicform-speaker-button {\n  transition: background-color .1s ease-in-out;\n  background-color: transparent;\n}\n\n.magicform-speaker-button:hover {\n  transition: background-color .1s ease-in-out;\n  background-color: lightgrey;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `magicform-chat-history`;
export { _1 as "magicform-chat-history" };
var _2 = `magicform-chat-history-minimal`;
export { _2 as "magicform-chat-history-minimal" };
var _3 = `magicform-chat-history-show-scrollbar`;
export { _3 as "magicform-chat-history-show-scrollbar" };
var _4 = `magicform-chat-history-hide-scrollbar`;
export { _4 as "magicform-chat-history-hide-scrollbar" };
var _5 = `magicform-chat-history-empty`;
export { _5 as "magicform-chat-history-empty" };
var _6 = `magicform-delete-button`;
export { _6 as "magicform-delete-button" };
var _7 = `magicform-scroll-anchor`;
export { _7 as "magicform-scroll-anchor" };
var _8 = `check-fade-in`;
export { _8 as "check-fade-in" };
export var fadeIn = `fadeIn`;
export var grow = `grow`;
var _9 = `magicform-speaker-button`;
export { _9 as "magicform-speaker-button" };
export default ___CSS_LOADER_EXPORT___;
